export default __webpack_public_path__ + "static/media/banner.31c07c7d.png";